import React from 'react';

type BadgeVariant = 'default' | 'script' | 'animation' | 'success' | 'warning' | 'info';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variants: Record<BadgeVariant, string> = {
  default: 'bg-rs-surfaceLight text-gray-300',
  script: 'bg-rs-accent/20 text-rs-accent border border-rs-accent/40',
  animation: 'bg-rs-secondary/20 text-red-300 border border-rs-secondary/40',
  success: 'bg-emerald-500/20 text-emerald-400',
  warning: 'bg-amber-500/20 text-amber-400',
  info: 'bg-rs-accent/15 text-rs-accent',
};

export default function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium
        ${variants[variant]} ${className}
      `}
    >
      {children}
    </span>
  );
}
